export function description(event) {
    const currentDescription = !event.event_description
                                    ? [event.event_short_slogan !== '' && event.event_short_slogan]
                                    : event.event_description
                                            .replace('No Sobre o Evento, segue texto:', '')
                                            .replaceAll('-,', '-')
                                            .split('\n')
    
    return currentDescription.filter(item => item !== '' && item !== ' ');
};